import { render } from "./FeaturedPostsComponent.vue?vue&type=template&id=727af934&scoped=true"
import script from "./FeaturedPostsComponent.vue?vue&type=script&lang=js"
export * from "./FeaturedPostsComponent.vue?vue&type=script&lang=js"

import "./FeaturedPostsComponent.vue?vue&type=style&index=0&id=727af934&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-727af934"]])

export default __exports__